import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { connect } from "react-redux";
import { ImageUploadDialog } from "components";
import BryanUhrigQRLogo from "_img/agentLogos/bryan_uhrig_qr.png";
import VillagePropertiesForbesLogo from "_img/agentLogos/village-properties-forbes.jpg";
import VillagePropertiesForbesLogo2 from "_img/agentLogos/village-properties-forbes2.png";
import VillagePropAndForbesLogo from "_img/agentLogos/village-prop-and-forbes-logo.png";
import LisaMLogo from "_img/agentLogos/LisaMLogo.png";
import SuzanneGarciaHeartLogo from "_img/agentLogos/suzanne-garcia-heart-logo.png";
import { pmaActions } from "_store/_actions";
import { isUserAdmin } from "common/roles/role";
import { GetOAuthToken } from "common/storage";
import "./print.scss";
//3rd page, the photo page, above the global note to the top right
class AgentLogoHeader extends Component {
  state = {
    isLogoStylesModalOpen: false,
    tp1stLogoURL: "",
    tp1stLogoStyle: "",
    tp1stLogoContainerStyles: "",
    tp2ndLogoURL: "",
    tp2ndLogoStyle: "",
    tp2ndLogoContainerStyle: "",
    logoStylesSnapshot: null,
    openLogoUploadDialog: false,
  };

  handleOpenLogoStylesModal = () => {
    const currentArea = this.props.currentArea || {};
    const areaFirstLogoURL =
      this.props &&
      this.props.currentArea &&
      this.props.currentArea.tp1stLogoURL !== undefined &&
      this.props.currentArea.tp1stLogoURL !== null
        ? this.props.currentArea.tp1stLogoURL
        : null;
    const initialFirstLogoURL =
      areaFirstLogoURL !== null
        ? areaFirstLogoURL
        : this.props &&
            this.props.agentData &&
            this.props.agentData.logoURL !== undefined
          ? this.props.agentData.logoURL
          : null;
    const areaTP1stLogoStyle = currentArea.tp1stLogoStyle || "";
    const areaTP1stLogoContainerStyles =
      currentArea.tp1stLogoContainerStyles ||
      currentArea.tp1stLogoContainerStyle ||
      "";
    const areaTP2ndLogoURL = currentArea.tp2ndLogoURL || "";
    const areaTP2ndLogoStyle = currentArea.tp2ndLogoStyle || "";
    const areaTP2ndLogoContainerStyle =
      currentArea.tp2ndLogoContainerStyle || "";

    this.setState({
      isLogoStylesModalOpen: true,
      tp1stLogoURL: initialFirstLogoURL,
      tp1stLogoStyle: areaTP1stLogoStyle,
      tp1stLogoContainerStyles: areaTP1stLogoContainerStyles,
      tp2ndLogoURL: areaTP2ndLogoURL,
      tp2ndLogoStyle: areaTP2ndLogoStyle,
      tp2ndLogoContainerStyle: areaTP2ndLogoContainerStyle,
      logoStylesSnapshot: {
        tp1stLogoURL: initialFirstLogoURL,
        tp1stLogoStyle: areaTP1stLogoStyle,
        tp1stLogoContainerStyles: areaTP1stLogoContainerStyles,
        tp2ndLogoURL: areaTP2ndLogoURL,
        tp2ndLogoStyle: areaTP2ndLogoStyle,
        tp2ndLogoContainerStyle: areaTP2ndLogoContainerStyle,
      },
    });
  };

  handleCloseLogoStylesModal = () => {
    this.setState({ isLogoStylesModalOpen: false });
  };

  handleCancelLogoStylesModal = () => {
    this.setState((prevState) => {
      const snapshot = prevState.logoStylesSnapshot || {};
      return {
        isLogoStylesModalOpen: false,
        tp1stLogoURL: snapshot.tp1stLogoURL || "",
        tp1stLogoStyle: snapshot.tp1stLogoStyle || "",
        tp1stLogoContainerStyles: snapshot.tp1stLogoContainerStyles || "",
        tp2ndLogoURL: snapshot.tp2ndLogoURL || "",
        tp2ndLogoStyle: snapshot.tp2ndLogoStyle || "",
        tp2ndLogoContainerStyle: snapshot.tp2ndLogoContainerStyle || "",
      };
    });
  };

  handleLogoStyleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  parseStyleString = (styleString) => {
    if (!styleString || typeof styleString !== "string") {
      return null;
    }

    const parsed = {};
    styleString
      .split(";")
      .map((rule) => rule.trim())
      .filter(Boolean)
      .forEach((rule) => {
        const [rawKey, ...valueParts] = rule.split(":");
        if (!rawKey || valueParts.length === 0) {
          return;
        }
        const key = rawKey
          .trim()
          .replace(/-([a-z])/g, (_, char) => char.toUpperCase());
        const value = valueParts.join(":").trim();
        if (!value) {
          return;
        }
        parsed[key] = value;
      });

    return Object.keys(parsed).length ? parsed : null;
  };

  parseLogoSizeClass = (logoStyleClass) => {
    if (!logoStyleClass || typeof logoStyleClass !== "string") {
      return null;
    }
    const sizeMatch = /^width-(\d+)-height-(\d+)$/.exec(logoStyleClass.trim());
    if (!sizeMatch) {
      return null;
    }
    return {
      "--logo-max-width": `${sizeMatch[1]}px`,
      "--logo-max-height": `${sizeMatch[2]}px`,
    };
  };

  openLogoUploadDialog = () => {
    this.setState({ openLogoUploadDialog: true });
  };

  closeLogoUploadDialog = () => {
    this.setState({ openLogoUploadDialog: false });
  };

  onLogoUploadSubmit = (uploadedImageUrl) => {
    this.setState({
      tp1stLogoURL: uploadedImageUrl || null,
      openLogoUploadDialog: false,
    });
  };

  updateTPLogos = () => {
    const { listgenUserID } = this.props.agentData || {};
    const { mlsAreaID } = this.props.currentArea || {};
    const formValues = {
      tp1stLogoURL: this.state.tp1stLogoURL,
      tp1stLogoStyle: this.state.tp1stLogoStyle,
      tp1stLogoContainerStyles: this.state.tp1stLogoContainerStyles,
      tp2ndLogoURL: this.state.tp2ndLogoURL,
      tp2ndLogoStyle: this.state.tp2ndLogoStyle,
      tp2ndLogoContainerStyle: this.state.tp2ndLogoContainerStyle,
    };
    const payload = [
      {
        listgenUserID: listgenUserID || "",
        areaID: mlsAreaID || "-",
        tp1stLogoURL: formValues.tp1stLogoURL,
        tp1stLogoStyle: formValues.tp1stLogoStyle,
        tp1stLogoContainerStyle: formValues.tp1stLogoContainerStyles,
        tp2ndLogoURL: formValues.tp2ndLogoURL,
        tp2ndLogoStyle: formValues.tp2ndLogoStyle,
        tp2ndLogoContainerStyle: formValues.tp2ndLogoContainerStyle,
      },
    ];

    if (typeof this.props.updateTPLogos === "function") {
      this.props.updateTPLogos(payload);
    }

    this.setState({
      isLogoStylesModalOpen: false,
      logoStylesSnapshot: formValues,
    });
  };

  shouldShowLogoStylesButton = () => {
    return false;
    const { fromEditor } = this.props;
    if (!fromEditor) {
      return false;
    }
    let oauthData = null;
    return true;
    try {
      const token = GetOAuthToken();
      oauthData = token ? JSON.parse(token) : null;
    } catch {
      oauthData = null;
    }

    return Boolean(oauthData && isUserAdmin(oauthData.roleID));
  };

  render() {
    const { printVersion } = this.props;
    const {
      isLogoStylesModalOpen,
      openLogoUploadDialog,
      tp1stLogoURL,
      tp1stLogoStyle,
      tp1stLogoContainerStyles,
      tp2ndLogoURL,
      tp2ndLogoStyle,
      tp2ndLogoContainerStyle,
    } = this.state;

    const { mlsAreaID, tp1stLogoURL: areaTP1stLogoURL } =
      this.props.currentArea || {};

    const { listgenUserID: uploadListgenUserID } = this.props.agentData || {};
    let {
      logoURL: agentLogoURL,
      listgenUserID,
      listgenUserFirstName,
      listgenUserLastName,
    } = this.props.agentData;

    let logoURL = areaTP1stLogoURL != null ? areaTP1stLogoURL : agentLogoURL;
    let containerStyle;
    if (mlsAreaID === "x45J") {
      logoURL =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/agent-MBP_Compas_LogoLockup-1775585896603.png";
    } else if (mlsAreaID === "SCL-233E") {
      logoURL =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/020926_Lynne-Caleb_logo.jpg";
    }
    let logoStyle;
    const isClaudiaM = listgenUserID === "100075";
    let isDavidKim = listgenUserID === "100778";
    let isDonPerry = listgenUserID === "101649";
    let isDerkBrill = listgenUserID === "105785";

    const isKyle3Team = listgenUserID === "103406";
    let isLynneMercer = listgenUserID === "102512";
    const isSummerChe = listgenUserID === "104113";

    if (listgenUserID === "x103680") {
      logoStyle = "teresa-m-agent-logo-bg-black";
    } else if (listgenUserID === "100661" || listgenUserID === "100652") {
      logoStyle = "width-270-height-65";
    } else if (
      listgenUserID === "112366" ||
      listgenUserID === "112334" ||
      listgenUserID === "109938" ||
      listgenUserID === "109973" ||
      listgenUserID === "109855" ||
      listgenUserID === "107130" ||
      listgenUserID === "101001" ||
      listgenUserID === "106463" ||
      listgenUserID === "102070" ||
      listgenUserID === "100560" ||
      listgenUserID === "107251"
    ) {
      logoStyle = "width-300-height-70";
    } else if (listgenUserID === "105056" || listgenUserID === "107280") {
      logoStyle = "long-agent-logo-header-v1";
    } else if (
      listgenUserID === "101003" ||
      listgenUserID === "100329" ||
      listgenUserID === "100216" ||
      listgenUserID === "100220" ||
      listgenUserID === "100152" ||
      listgenUserID === "100171" ||
      listgenUserID === "100134" ||
      listgenUserID === "100129" ||
      listgenUserID === "100076" ||
      listgenUserID === "100026" ||
      listgenUserID === "100314" ||
      listgenUserID === "100462" ||
      listgenUserID === "100567" ||
      listgenUserID === "100588"
    ) {
      containerStyle = "less-margin-agent-logo-header";
      logoStyle = "tall-agent-logo";
    }
    if (
      listgenUserID === "106655" ||
      listgenUserID === "103455" ||
      listgenUserID === "104747"
    ) {
      logoStyle = "agent-logo-header-height-45";
    } else if (listgenUserID === "106145") {
      containerStyle = "meg-robert-logo-container";
      logoStyle = "meg-logo";
    } else if (
      listgenUserID === "100401" ||
      // listgenUserID === "100778" ||
      listgenUserID === "100374" ||
      listgenUserID === "101677" ||
      listgenUserID === "100528" ||
      listgenUserID === "100474" ||
      listgenUserID === "100585" ||
      listgenUserID === "101332" ||
      listgenUserID === "102641" ||
      listgenUserID === "105790" ||
      listgenUserID === "102843" ||
      listgenUserID === "105047" ||
      listgenUserID === "105795" ||
      listgenUserID === "104113" ||
      listgenUserID === "105799" ||
      listgenUserID === "102694" ||
      listgenUserID === "104412" ||
      listgenUserID === "102734" ||
      listgenUserID === "105851" ||
      listgenUserID === "105100" ||
      listgenUserID === "104804" ||
      listgenUserID === "102712" ||
      listgenUserID === "102660" ||
      listgenUserID === "106472" ||
      listgenUserID === "104819" ||
      listgenUserID === "105896" ||
      listgenUserID === "107012" ||
      listgenUserID === "105856" ||
      listgenUserID === "105959" ||
      listgenUserID === "106144" ||
      listgenUserID === "106550" ||
      listgenUserID === "102962" ||
      listgenUserID === "102501" ||
      listgenUserID === "106397" ||
      listgenUserID === "102941" ||
      listgenUserID === "102975" ||
      listgenUserID === "107254" ||
      listgenUserID === "107215" ||
      listgenUserID === "106991" ||
      listgenUserID === "109954" ||
      listgenUserID === "109889" ||
      listgenUserID === "109680" ||
      listgenUserID === "109696" ||
      listgenUserID === "109805" ||
      listgenUserID === "101268" ||
      listgenUserID === "105915" ||
      listgenUserID === "106450" ||
      listgenUserID === "107248" ||
      listgenUserID === "107348" ||
      listgenUserID === "107521" ||
      listgenUserID === "112369" ||
      listgenUserID === "115920" ||
      listgenUserID === "113592" ||
      listgenUserID === "107304" ||
      listgenUserID === "113607" ||
      listgenUserID === "115914" ||
      listgenUserID === "112330" ||
      listgenUserID === "116097" ||
      listgenUserID === "120440"
    ) {
      containerStyle = "reduced-agent-logo-header";
      logoStyle = "width-250-height-75";
    } else if (
      listgenUserID === "104835" ||
      listgenUserID === "104504" ||
      listgenUserID === "107243" ||
      listgenUserID === "107305" ||
      listgenUserID === "107319" ||
      listgenUserID === "107863" ||
      listgenUserID === "107873" ||
      listgenUserID === "108188" ||
      listgenUserID === "109809" ||
      listgenUserID === "112368" ||
      listgenUserID === "102288" ||
      listgenUserID === "100656" ||
      listgenUserID === "109901" ||
      listgenUserID === "102286" ||
      listgenUserID === "115902" ||
      listgenUserID === "114383" ||
      listgenUserID === "113013" ||
      listgenUserID === "104480" ||
      listgenUserID === "109834" ||
      listgenUserID === "115936" ||
      listgenUserID === "120535"
    ) {
      logoStyle = "height-80-width-300-agent-logo-header";
    } else if (
      listgenUserID === "100567" ||
      listgenUserID === "100056" ||
      listgenUserID === "100047" ||
      listgenUserID === "100074" ||
      listgenUserID === "100458" ||
      listgenUserID === "100778" ||
      listgenUserID === "105473" ||
      listgenUserID === "104626" ||
      listgenUserID === "104510" ||
      listgenUserID === "105678" ||
      listgenUserID === "102674" ||
      listgenUserID === "100746" ||
      listgenUserID === "100040"
    ) {
      containerStyle = "reduced-agent-logo-header";
      logoStyle = "reduced-width-agent-logo-header";
    } else if (
      listgenUserID === "101566" ||
      listgenUserID === "104519" ||
      listgenUserID === "104874"
    ) {
      containerStyle = "xxl-agent-logo-header";
      logoStyle = "triple-x-agent-logo";
    } else if (listgenUserID === "103405" || listgenUserID === "110030") {
      containerStyle = "reduced-agent-logo-header";
      logoStyle = "larger-logo";
    } else if (listgenUserID === "112993") {
      logoStyle = "agent-logo-height-105-mt-neg-15";
    } else if (
      listgenUserID === "102809" ||
      listgenUserID === "102340" ||
      listgenUserID === "106421" ||
      listgenUserID === "105797" ||
      listgenUserID === "105068" ||
      listgenUserID === "107294" ||
      listgenUserID === "107001" ||
      listgenUserID === "109860" ||
      listgenUserID === "100138" ||
      listgenUserID === "105189" ||
      listgenUserID === "109873" ||
      listgenUserID === "106024" ||
      listgenUserID === "102653" ||
      listgenUserID === "112350" ||
      listgenUserID === "112336" ||
      listgenUserID === "115901" ||
      listgenUserID === "110067" ||
      listgenUserID === "109832" ||
      listgenUserID === "116066" ||
      listgenUserID === "116347" ||
      listgenUserID === "116072" ||
      listgenUserID === "109879" ||
      listgenUserID === "116885" ||
      listgenUserID === "115897" ||
      listgenUserID === "105037" ||
      listgenUserID === "116884" ||
      listgenUserID === "109705" ||
      listgenUserID === "116930" ||
      listgenUserID === "116929" ||
      listgenUserID === "116921" ||
      listgenUserID === "117071" ||
      listgenUserID === "117364" ||
      listgenUserID === "117968" ||
      listgenUserID === "120408" ||
      listgenUserID === "120543" ||
      listgenUserID === "120599"
    ) {
      logoStyle = "agent-logo-height-85";
    } else if (listgenUserID === "108283") {
      logoStyle = "agent-logo-height-85 auto-height";
    } else if (
      listgenUserID === "100348" ||
      listgenUserID === "106578" ||
      listgenUserID === "102808" ||
      listgenUserID === "102507" ||
      listgenUserID === "105222" ||
      listgenUserID === "102481" ||
      listgenUserID === "105016" ||
      listgenUserID === "102995" ||
      listgenUserID === "101479" ||
      listgenUserID === "105810" ||
      listgenUserID === "104709" ||
      listgenUserID === "102551" ||
      listgenUserID === "106543" ||
      listgenUserID === "106531" ||
      listgenUserID === "105830" ||
      listgenUserID === "106433" ||
      listgenUserID === "106141" ||
      listgenUserID === "106661" ||
      listgenUserID === "100210" ||
      listgenUserID === "107037" ||
      listgenUserID === "107022" ||
      listgenUserID === "102535" ||
      listgenUserID === "106399" ||
      listgenUserID === "107253" ||
      listgenUserID === "107270" ||
      listgenUserID === "104683" ||
      listgenUserID === "104597" ||
      listgenUserID === "104742" ||
      listgenUserID === "117955"
    ) {
      logoStyle = "width-250-height-80";
      containerStyle = "xxl-agent-logo-header";
    } else if (listgenUserID === "109938" || listgenUserID === "109973") {
      containerStyle = "agent-logo-mt-35";
    }

    if (
      listgenUserID === "115951" ||
      listgenUserID === "115999" ||
      listgenUserID === "116001" ||
      listgenUserID === "116045" ||
      listgenUserID === "116399" ||
      listgenUserID === "114820"
    ) {
      logoStyle = "width-250-height-90";
    } else if (listgenUserID === "109864") {
      containerStyle = "centered-logo-full-height";
      logoStyle = "agent-logo-height-30-width-220";
    } else if (listgenUserID === "105867") {
      logoStyle = "agent-logo-height-25";
    } else if (
      listgenUserID === "100038" ||
      listgenUserID === "100059" ||
      listgenUserID === "100031" ||
      listgenUserID === "100483" ||
      listgenUserID === "105867" ||
      listgenUserID === "104607" ||
      listgenUserID === "107289"
    ) {
      logoStyle = "width-300-height-35";
    } else if (
      listgenUserID === "100015" ||
      listgenUserID === "100049" ||
      listgenUserID === "100054" ||
      listgenUserID === "102833" ||
      listgenUserID === "102753" ||
      listgenUserID === "106031" ||
      listgenUserID === "109652" ||
      listgenUserID === "102894" ||
      listgenUserID === "107232" ||
      listgenUserID === "109651" ||
      listgenUserID === "109796"
    ) {
      logoStyle = "width-290-height-50";
    } else if (
      listgenUserID === "100227" ||
      listgenUserID === "100411" ||
      listgenUserID === "103404" ||
      listgenUserID === "105789" ||
      listgenUserID === "102802" ||
      listgenUserID === "106647" ||
      listgenUserID === "107300" ||
      listgenUserID === "102627" ||
      listgenUserID === "108245" ||
      listgenUserID === "108184" ||
      listgenUserID === "110007" ||
      listgenUserID === "109989" ||
      listgenUserID === "109657" ||
      listgenUserID === "103406"
    ) {
      logoStyle = "width-300-height-65";
    } else if (listgenUserID === "x") {
      logoStyle = "width-275-height-60";
    } else if (
      listgenUserID === "116936" ||
      listgenUserID === "110861" ||
      listgenUserID === "107230" ||
      listgenUserID === "120423"
    ) {
      logoStyle = "width-200-height-60";
    }
    let isSuzanneGarcia = listgenUserID === "106647";
    if (listgenUserID === "100902") {
      logoURL = VillagePropAndForbesLogo;
    } else if (isSuzanneGarcia) {
      logoURL = SuzanneGarciaHeartLogo;
    }
    const hasTP1stLogoStyle = Boolean(tp1stLogoStyle && tp1stLogoStyle.trim());
    const tp1stLogoInlineStyle = hasTP1stLogoStyle
      ? this.parseStyleString(tp1stLogoStyle)
      : null;
    const logoSizeFromClass = this.parseLogoSizeClass(logoStyle);
    const mergedLogoStyle = {
      ...(logoSizeFromClass || {}),
      ...(tp1stLogoInlineStyle || {}),
    };

    const isUhrig = listgenUserID === "100568";
    const isDianneJohnson = listgenUserID === "100988";
    let showLogo = true;
    if (listgenUserID === "109873") {
      showLogo = false;
    }
    const canShowLogoStylesButton = this.shouldShowLogoStylesButton();
    //const canShowLogoStylesButton = false;

    return (
      <div>
        {openLogoUploadDialog && (
          <ImageUploadDialog
            openDialog={openLogoUploadDialog}
            onSubmit={this.onLogoUploadSubmit}
            onClose={this.closeLogoUploadDialog}
            imageType="logo"
            listgenUserID={String(uploadListgenUserID || "")}
            currentImage={tp1stLogoURL}
            isMyAccountUpload={true}
          />
        )}
        <Dialog
          open={isLogoStylesModalOpen}
          onClose={this.handleCloseLogoStylesModal}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            {`Change agent logo header styles for ${listgenUserFirstName || ""} ${listgenUserLastName || ""}.`}
            <div className="agent-logo-user-id-line">
              {`ListGenUserID: ${listgenUserID || ""}`}
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div className="agent-logo-styles-modal-body">
              <div className="agent-logo-styles-field">
                <label htmlFor="tp1stLogoURL">First Logo URL</label>
                <input
                  id="tp1stLogoURL"
                  name="tp1stLogoURL"
                  value={tp1stLogoURL}
                  onChange={this.handleLogoStyleInputChange}
                />
                <div className="agent-logo-upload-row">
                  <button
                    type="button"
                    className="agent-logo-upload-button"
                    onClick={this.openLogoUploadDialog}
                  >
                    Upload Logo
                  </button>
                  {tp1stLogoURL ? (
                    <div className="agent-logo-upload-preview">
                      <img
                        src={tp1stLogoURL}
                        alt="Uploaded first logo preview"
                        onError={(event) => {
                          event.currentTarget.style.display = "none";
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="agent-logo-styles-field">
                <label htmlFor="tp1stLogoStyle">First Logo Styles</label>
                <input
                  id="tp1stLogoStyle"
                  name="tp1stLogoStyle"
                  value={tp1stLogoStyle}
                  onChange={this.handleLogoStyleInputChange}
                />
              </div>
              <div className="agent-logo-styles-field">
                <label htmlFor="tp1stLogoContainerStyles">
                  First Logo Container Styles
                </label>
                <input
                  id="tp1stLogoContainerStyles"
                  name="tp1stLogoContainerStyles"
                  value={tp1stLogoContainerStyles}
                  onChange={this.handleLogoStyleInputChange}
                />
              </div>
              <div className="agent-logo-styles-field">
                <label htmlFor="tp2ndLogoURL">Second Logo URL</label>
                <input
                  id="tp2ndLogoURL"
                  name="tp2ndLogoURL"
                  value={tp2ndLogoURL}
                  onChange={this.handleLogoStyleInputChange}
                />
              </div>
              <div className="agent-logo-styles-field">
                <label htmlFor="tp2ndLogoStyle">Second Logo Style</label>
                <input
                  id="tp2ndLogoStyle"
                  name="tp2ndLogoStyle"
                  value={tp2ndLogoStyle}
                  onChange={this.handleLogoStyleInputChange}
                />
              </div>
              <div className="agent-logo-styles-field">
                <label htmlFor="tp2ndLogoContainerStyle">
                  Second Logo Container Style
                </label>
                <input
                  id="tp2ndLogoContainerStyle"
                  name="tp2ndLogoContainerStyle"
                  value={tp2ndLogoContainerStyle}
                  onChange={this.handleLogoStyleInputChange}
                />
              </div>
              <div className="agent-logo-styles-modal-actions">
                <button
                  type="button"
                  className="agent-logo-styles-cancel-button"
                  onClick={this.handleCancelLogoStylesModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="agent-logo-styles-submit-button"
                  onClick={this.updateTPLogos}
                >
                  Submit
                </button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <div
          className={`${
            printVersion
              ? "print-agent-logo-header"
              : "editor-agent-logo-header"
          } ${containerStyle} ${canShowLogoStylesButton ? "with-logo-styles-button" : ""}`}
        >
          {canShowLogoStylesButton && (
            <button
              type="button"
              className="agent-logo-styles-button"
              onClick={this.handleOpenLogoStylesModal}
            >
              Logo Styles (ADMIN ONLY)
            </button>
          )}

          {isSummerChe && (
            <img
              className="summer-che-agent-logo-header"
              src="https://d2onbxnrte2nim.cloudfront.net/SummerChe_Black_LOGO.png"
              alt="Summer Che Logo"
            />
          )}
          {listgenUserID === "100040" && (
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/CFSP_Seal_Standard_500px.png"
              alt="Amber Russell Seal"
              className="amber-russell-agent-logo-header"
            />
          )}
          {showLogo &&
            !isSummerChe &&
            !isDianneJohnson &&
            listgenUserID !== "100746" &&
            listgenUserID !== "106020" &&
            listgenUserID !== "109818" &&
            logoURL && (
              <img
                className={`agent-logo-header-img ${logoStyle}`}
                // className={`agent-logo-header-img ${hasTP1stLogoStyle ? "" : logoStyle}`}
                // style={
                //   Object.keys(mergedLogoStyle).length
                //     ? mergedLogoStyle
                //     : undefined
                // }
                src={
                  isDerkBrill
                    ? "https://d2onbxnrte2nim.cloudfront.net/compressed-derkbrill-horizontal.jpg"
                    : isDonPerry
                      ? "https://d2onbxnrte2nim.cloudfront.net/LP-GROUP_logo_2_111722-01.png"
                      : listgenUserID === "100585"
                        ? "https://d2onbxnrte2nim.cloudfront.net/040623_DSamuel_D-S-Logo_500px_(2).png"
                        : logoURL
                }
                alt="agent logo"
              />
            )}
          {listgenUserID === "106145" && (
            <img
              className="robert-parish-logo"
              src="https://d2onbxnrte2nim.cloudfront.net/RobertParish_MonogramBlack_horizontal.png"
              alt="Robert Parish Logo"
            />
          )}
          {isUhrig && (
            <img
              className="uhrig-agent-logo-header"
              src={BryanUhrigQRLogo}
              alt="Bryan Uhrig Logo"
            />
          )}
          {mlsAreaID === "xSCL-233E" && (
            <img
              className="uhrig-agent-logo-header"
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/031424_Caleb+Fenner_Logo.png"
              alt="Caleb Fenner Logo"
            />
          )}
          {(isDianneJohnson || listgenUserID === "100746") && (
            <img
              className="dianne-johnson-agent-logo-header"
              src={VillagePropertiesForbesLogo2}
              alt="Village Properties Forbes Logo"
            />
          )}
          {listgenUserID === "104747" && (
            <img
              className="sheldon-rilliet-logo-header"
              src="https://d2onbxnrte2nim.cloudfront.net/112124_Sheldon_LOGO.png"
              alt="Sheldon Rilliet Logo"
            />
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateTPLogos: (tpLogosDetails) => {
      dispatch(pmaActions.updateTPLogos(tpLogosDetails));
    },
  };
};

export default connect(null, mapDispatchToProps)(AgentLogoHeader);
